import React from 'react';
import { translate } from 'react-i18next';
import styled from 'styled-components';

import RightChevron from './RightChevron';

const Button = styled.button`
  color: ${props => props.theme.onPrimary}
  fill: ${props => props.theme.onPrimary}
  width: 140px;
  height: 50px;
  font-size: 14px;
  background: ${props => props.theme.primary};
  border: none;
  text-align: left;
  cursor: pointer;
`;

const Text = styled.span`
  margin-left: 39px;
`;

const Chevron = styled.span`
  margin-left: 13px;
`;

const NextPageButton = ({ t, ...others }) => (
  <Button {...others}>
    <Text>{t('button.next')}</Text>
    <Chevron>
      <RightChevron />
    </Chevron>
  </Button>
);

export default translate()(NextPageButton);
